import React, { useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import { useNavigate, useSearchParams } from "react-router-dom";
import "./MLRPDF.scss";
import DashboardImage from "../../images/DashboardImage.svg";
import { ExportDeckToMail, getMLRStatus } from "../../services/apis";
import CircularProgressBar from "../../utils/CircularProgressBar";
import { Dropdown } from "react-bootstrap";
import { showErrorToast, showSuccessToast } from "../toastComponent/ToastComponent";
import CustomTooltip from "../Tooltip/Tooltip";
import FailedIcon from '../../images/FAILED.svg';
import { isDeckEditable } from "../../utils/editorUtils/commonFunctions";
import warning from "../../images/warning-black-icon.svg"
import { allowedDocStatus, allowedProductList } from "../../constant/veeva";

const MLRPDFHeader = ({
  setOpenMLRPDF,
  setExportFormats,
  pdfURL,
  deckData,
  setMLR,
  setClickOnSubmit,
  clickOnSubmit,
  handleApprovedtemplateModal,
  submitMLR,
  loading,
  setLoading,
  mlrData,
  setPreviewLoading,
  previewData,
  submitHTML,
  minorVersion,
  isOTC
}) => {
  const navigate = useNavigate();

  const [publishList, setPublishList] = useState(["Publish PDF", "Publish HTML"]);
  const [downloadList, setDownloadList] = useState(["Download PDF", "Download HTML"]);
  const [publishDropdown, setPublishDropdown] = useState(false);
  const [downloadDropdown, setDownloadDropdown] = useState(false);
  const [currentUserId, setCurrentUserId] = useState("");
  const [deckEditable, setDeckEditable] = useState(false);

  useEffect(() => {
    const user = localStorage?.getItem("userId") || "";
    setCurrentUserId(user);
  }, []);

  
  useEffect(() => {
    if(previewData && currentUserId) {
      const prevAndDeckData = {...previewData, brandAndCountryDetails: deckData};
      const editable = isDeckEditable(prevAndDeckData, currentUserId);
      setDeckEditable(editable);
    }
  }, [previewData, currentUserId]);

  // const downlaodPDF = (pdfURL) => {
  //   const pdflink = document.createElement("a");
  //   pdflink.href = deckData.pdfURL;
  //   pdflink.download = "download.pdf";
  //   pdflink.dispatchEvent(new MouseEvent("click"));
  // };
  function downlaodPDF(pdfURL) {
    const downloadUrl = pdfURL || deckData.pdfURL;
    fetch(downloadUrl, { cache: "no-store" })
      .then((res) => res.blob())
      .then((file) => {
        const blobUrl = URL.createObjectURL(file);
        const pdflink = document.createElement("a");
        pdflink.href = blobUrl;
        pdflink.download = `${deckData?.docNumber || deckData?.name || "download"}.pdf`;
        pdflink.dispatchEvent(new MouseEvent("click"));
        URL.revokeObjectURL(blobUrl);
        showSuccessToast("Download successful");
      })

      .catch(() => {
        showErrorToast("Download failed. Pl try again");
      });
  }

  const goToDashboard = () => {
    navigate(`/${previewData?.type == 1 ? "template" : "edetail"}-manager`);
  };

  const validateMlsrStatus = () => {
    setPreviewLoading(true);// 
    getMLRStatus(deckData.id, true,async (response, err, errorCode) => {
      if(err?.code === "ERR_NETWORK") {
        showErrorToast('Network not found. Pl reconnect to continue');
        setPreviewLoading(false);
      } else if (err) {
        setPreviewLoading(false);
      } else {
        setPreviewLoading(false);
        const currentSatus = response?.data?.response;
        if (
          currentSatus.statusMLR === "Approved for Production" ||
          currentSatus.statusMLR === "Approved with Changes" ||
          currentSatus.statusMLR === "GRC Process Complete"
        ) {
          handleApprovedtemplateModal();
        } else {
          if(currentSatus.docMinorVersion == minorVersion) {
            submitMLR();
          } else {
            showErrorToast('Please make some changes before publishing again');
          }
        }
      }
    });
  };

  const selectPublishHandler = (item) => {
    
    // setExpand(prev => !prev);
  }

  const publishDropdownHandler = (isOpen) => {
    setPublishDropdown(isOpen);
  }

  const downloadDropdownHandler = (isOpen) => {
    setDownloadDropdown(isOpen);
  }

  const downloadHTML = () => {
    ExportDeckToMail(deckData.id, (response, err, errorCode) => {
            if (err) {
              console.log(err)
            } else {
              showSuccessToast("Download link will be emailed");
              // showSuccessToast(response.data || "Your link will be emailed shortly.");
            }
          });
  }

  const grayedOutPublish = () => {
    const invalidStatuses = [
      "draft",
      "not submitted",
      "reviewed with minor changes",
      "approved with minor changes"
    ];

    const disabledPublish = previewData?.veevaMetadata?.find(li => li?.assetType === 1);
    
    if(deckData?.country === "France") {
      const isAllowedStatus = allowedDocStatus.franceAllowedDocStatus?.includes(disabledPublish?.docStatus?.toUpperCase());
      // return !(disabledPublish && isAllowedStatus) 
      if (disabledPublish && isAllowedStatus) {
        return false;
      } else {
        return true;
      }
    }

    if(deckData?.country === "United States" && allowedProductList.usMarketAllowedProductList?.includes(deckData?.brand?.toUpperCase())) {
      const isAllowedStatus = allowedDocStatus.usMarketAllowedDocStatus?.includes(disabledPublish?.docStatus?.toUpperCase());
      if (disabledPublish && isAllowedStatus) {
        return false;
      } else {
        return true;
      }
    }

    if (
      deckData?.country === "Israel" &&
      allowedProductList.israelAllowedProductList?.includes(deckData?.brand?.toUpperCase())
    ) {
      const isAllowedStatus = allowedDocStatus.israelAllowedDocStatus?.includes(
        disabledPublish?.docStatus?.toUpperCase()
      );
      if (disabledPublish && isAllowedStatus) {
        return false;
      } else {
        return true;
      }
    }

    if (
      deckData?.country === "Greece & Cyprus" &&
      allowedProductList.greeceAllowedProductList?.includes(deckData?.brand?.toUpperCase())
    ) {
      const isAllowedStatus = allowedDocStatus.greeceAllowedDocStatus?.includes(
        disabledPublish?.docStatus?.toUpperCase()
      );
      if (disabledPublish && isAllowedStatus) {
        return false;
      } else {
        return true;
      }
    }

    if (
      deckData?.country === "Switzerland" &&
      allowedProductList.switzerlandAllowedProductList?.includes(deckData?.brand?.toUpperCase())
    ) {
      const isAllowedStatus = allowedDocStatus.switzerlandAllowedDocStatus?.includes(
        disabledPublish?.docStatus?.toUpperCase()
      );
      if (disabledPublish && isAllowedStatus) {
        return false;
      } else {
        return true;
      }
    }

    if (disabledPublish && invalidStatuses.includes(disabledPublish?.docStatus?.toLowerCase())) {
      return false;
    } else {
      return true;
    }
  }

  const currentDocStatus = previewData?.veevaMetadata?.find(
    (li) => li?.assetType === 1
  )?.docStatus;

  useEffect(() => {
    if (grayedOutPublish()) {
      setPublishDropdown(false);
    }
  }, [currentDocStatus, deckData?.country, deckData?.brand]);

  const backToEditor = () => {
    if(!deckEditable) return;
    navigate(`/editor/${previewData.slides[0]?.slideid._id}`, {
      state: { data: previewData }
    });
  }


  return (
    <>
      <CircularProgressBar isloading={loading} />
      <div className="export-pdf-header">
        <div className="d-flex align-items-center justify-content-between" style={{ height: "100%", width: "100%", padding: "0 20px 0 8px"}}>
          <div className="export-pdf-left-section d-flex align-items-center">
            <div className="d-flex align-items-center justify-content-between" style={{borderRight: '1px solid #DAE5F2', marginRight: "16px", height: "32px"}}>
              <img
                src={DashboardImage}
                alt=""
                className="backarowPreview"
                onClick={goToDashboard}
              />
            </div>
            <div style={{position:"relative"}}>
              <h2>create {previewData?.type == 1 ? "Template" : "e-Detail"}</h2>
              <CustomTooltip title={deckData.name} classes="export-pdf-left-section-tooltip">
                <h3>{deckData.name}</h3>
              </CustomTooltip>
              {isOTC && (
                <div className="export-pdf-left-section-OTC">OTC <img src={warning} ></img></div>
              )}
            </div>
          </div>
          <div className="export-pdf-right-section d-flex">
            <Button className="editBtn-rsdPreview" onClick={backToEditor} disabled={!deckEditable}>EDIT</Button>
            <Dropdown
              show={downloadDropdown}
              onToggle={downloadDropdownHandler}
              className="export-pdf-download-dropdown"
            >
              <Dropdown.Toggle className={`export-pdf-download ${!downloadDropdown ? "export-pdf-download-collapse-icon" : "export-pdf-download-expand-icon"}`}>
                DOWNLOAD
              </Dropdown.Toggle>
              <Dropdown.Menu className="export-pdf-download-menu" style={{ width: '100px'}}>
                {downloadList?.map((item, index)=> <Dropdown.Item
                  onClick={() => item === "Download PDF" ? downlaodPDF(pdfURL) : downloadHTML()}
                >
                  <span key={index}>
                    {item}
                  </span>
                </Dropdown.Item>)}
              </Dropdown.Menu>
            </Dropdown>
            {/* } */}
            {previewData?.type == 1 ? <Button
              className="button export-pdf-publish"
              onClick={() => {
                if (mlrData) {
                  validateMlsrStatus();
                } else {
                  submitMLR();
                }
              }}
              disabled={grayedOutPublish()}
            >
              PUBLISH
            </Button>
            : <Dropdown
                show={publishDropdown}
                onToggle={publishDropdownHandler}
                className=""
              >
                <Dropdown.Toggle disabled={grayedOutPublish()} className={`export-pdf-publish ${!publishDropdown ? "export-pdf-publish-collapse-icon" : "export-pdf-publish-expand-icon"}`}>
                  PUBLISH
                </Dropdown.Toggle>
                <Dropdown.Menu className={`publish-dropdown-menu ${previewData?.veevaMetadata?.find(li => li.assetType === 1).docStatus === "Not Submitted" ? "publish-dropdown-menu-disabled" : ""}`}>
                  {publishList?.map((item, index)=> <Dropdown.Item
                    disabled={item === "Publish HTML" ? previewData?.veevaMetadata?.find(li => li.assetType === 1).docStatus === "Not Submitted" ? true : false : false}
                    // onClick={() => {
                    //   selectPublishHandler(item)}
                    // }
                    onClick={() => {
                      if(item === "Publish PDF") {
                        if (mlrData) {
                          validateMlsrStatus();
                        } else {
                          submitMLR();
                        }
                      } else {
                        submitHTML()
                      }
                    }}
                  >
                    <span>
                      {item}
                    </span>
                  </Dropdown.Item>)}
                </Dropdown.Menu>
              </Dropdown>
            }
          </div>
        </div>
      </div>
    </>
  );
};

export default MLRPDFHeader;
